import { z } from 'zod'

const EventSchema = z.object({
    name: z.string(),
    enabled: z.boolean(),
})

export const ThirdPartyScriptDataSchema = z.object({
    clarity: z.object({
        enabled: z.boolean(),
        config: z.object({
            projectId: z.string(),
        }),
    }),
    gtm: z.object({
        enabled: z.boolean(),
        config: z.object({
            containerId: z.string(),
        }),
        events: z.array(EventSchema),
    }),
    internal: z.object({
        enabled: z.boolean(),
        events: z.array(EventSchema),
    }),
    internal2: z.object({
        enabled: z.boolean(),
        events: z.array(EventSchema),
    }),
    webengage: z.object({
        enabled: z.boolean(),
        config: z.object({
            identifierId: z.string().regex(/^[a-zA-Z0-9]+$/, 'identifierId must be alphanumeric'),
            isGzip: z.boolean(),
            proxy: z.discriminatedUnion('enabled', [
                z.object({
                    enabled: z.literal(true),
                    url: z.string().url(),
                }),
                z.object({ enabled: z.literal(false) }),
            ]),
        }),
    }),
})

export type SingleEvent = z.infer<typeof EventSchema>
export type ThirdPartyScriptData = z.infer<typeof ThirdPartyScriptDataSchema>
